<app-loading *ngIf="loading" width="36" [show]="true"></app-loading>
<div class="modal" *ngIf="!loading">
  <div class="custom-scrollbar scroll">
    <div *ngIf="showHeader" class="header">
      <p class="title">{{ title | translate }}</p>
      <div *ngIf="showHeaderButtons" class="buttons">
        <app-button
          class="cancel-btn"
          [disabled]="acceptLoading"
          (onClick)="hide()"
          [label]="cancelButtonText | translate"
          [secondary]="true"
        ></app-button>
        <app-button
          class="accept-btn"
          [disabled]="acceptDisabled"
          [loading]="acceptLoading"
          (onClick)="accept()"
          [label]="acceptButtonText | translate"
        ></app-button>
      </div>
    </div>
    <div class="info-panel" [class.success]="success" [class.error]="error">
      <p *ngIf="success || error" [class.bold]="!firstPartMessage">
        <span *ngIf="firstPartMessage"
          >{{ firstPartMessage | translate }}.</span
        >
        {{ message | translate }}.
      </p>
    </div>
    <div
      class="custom-scrollbar scrollbar-content"
      [ngStyle]="{ 'max-height.px': maxHeight }"
    >
      <div class="modal-content">
        <div #content class="content"></div>
        <ng-content *ngIf="!component"></ng-content>
      </div>
    </div>
  </div>
</div>
